import { useRescheduleContext } from '../../../contexts/RescheduleProvider';
import { AppointmentHistory } from '../../../types/history';

const AppointmentDetailsCol = ({
  history,
  isAssociate,
}: {
  history: AppointmentHistory;
  isAssociate?: boolean;
}) => {
  // integration of context hooks here
  const { setShowDetailsModal, setIsAssociate, setAppointment } =
    useRescheduleContext();

  // rendering appointment history details column component here
  return (
    <div>
      <button
        onClick={() => {
          setShowDetailsModal(true);
          setIsAssociate(isAssociate ? isAssociate : false);
          setAppointment(history);
        }}
        className='font-medium text-base-light-blue hover:opacity-70 active:scale-95 duration-300'
      >
        {isAssociate ? history.client_full_name : history.associate_full_name}
      </button>
    </div>
  );
};

export default AppointmentDetailsCol;
